import React, { useLayoutEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import CopyToClipboard from 'react-copy-to-clipboard';
import ReactTimeago from 'react-timeago';
import { FaCopy } from 'react-icons/fa';

import { animationPropsSlide } from '../animationSettings';
import { ChatItemModel } from '../types/Models';

export interface ChatItemProps {
  item: ChatItemModel;
}

const ChatItem: React.FC<ChatItemProps> = ({ item }) => {
  const [expanded, setExpanded] = useState(false);
  const messageRef = useRef<HTMLDivElement>(null);
  const clientName = item.clientName;
  const clientColor = item.clientColor;
  const message = item.message;
  const date = item.date;

  useLayoutEffect(() => {
    if (messageRef.current?.offsetHeight < 50) {
      setExpanded(true);
    }
  }, [setExpanded]);

  return (
    <motion.li
      className={'subsection info-grid ' + (expanded ? 'chat-expanded' : '')}
      {...animationPropsSlide}
      aria-label="Chat message"
    >
      <div className="chat-info">
        <div
          className="network-tile target-tile"
          style={{
            backgroundColor: clientColor,
          }}
        />
        <div>
          <ReactTimeago date={date} />
        </div>
        <CopyToClipboard text={message}>
          <button className="chat-action">
            <FaCopy />
          </button>
        </CopyToClipboard>
      </div>
      <div className="chat-message" ref={messageRef}>
        {message}
      </div>
      {!expanded && (
        <button className="chat-message-more" onClick={() => setExpanded(true)}>
          Show more
        </button>
      )}
    </motion.li>
  );
};

export default ChatItem;
